import React from 'react';

const footer = () => {
    return(
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <a href="https://www.envato.com" target="_blank" rel="noreferrer">
                            <span className="copy"> </span>
                        </a>
                    </div>
                    <div className="col-md-6">
                        <div className="social-icons">
                            <a href="https://www.facebook.com/dawood.israr.7" rel="noreferrer"><i className="fa fa-facebook"></i></a>
                            <a href="https://www.linkedin.com/in/dawood-israr-8aaa4a232/" rel="noreferrer"><i className="fa fa-linkedin"></i></a>
                            <a href="https://github.com/DawoodIsrar" rel="noreferrer"><i className="fa fa-github"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default footer;